module.exports = __webpack_public_path__ + "static/media/OE.f78bb938.jpg";